import React from 'react';
import {Card} from "../../../../components/card/card.jsx";
import projectUtils from "../../../../utils/project-utils.js";
import {getBackgroundImage} from "../utils/individual-passage-search-utils.js";

const PassageResults = ({events, selectedId, hasSelection, onSelectEvent}) => {
    return (
        <Card className={"ips-default-max-height self-start flex-1"}>
            <Card.Body>
                {
                    !events &&
                    <div className={"rounded border border-sky-200 bg-sky-100 text-sky-800 font-bold p-3 m-0"}>
                        * Preencha com um CPF ou faça o upload de uma imagem antes de realizar a pesquisa.
                    </div>
                }

                {
                    events && !events.length &&
                    <div id={"empty-list"} className={"rounded border border-sky-200 bg-sky-100 text-sky-800 font-bold p-3 m-0"}>
                        Nenhum registro encontrado.
                    </div>
                }

                {
                    events && events.length > 0 &&
                    <>
                        <div className={"grid gap-2 px-1 mb-2 " + (hasSelection ? "grid-cols-3" : "grid-cols-4")}>
                            {
                                events.map((event, i) => (
                                    <div
                                        className={"bg-white rounded-[0.5rem] border border-[#ededed] cursor-pointer relative" + (selectedId === i ? " ips-card-selected" : "")}
                                        key={i}
                                        onClick={() => onSelectEvent(event, i)}
                                    >
                                        <div className={"p-[10px]"}>
                                            <div className={"flex flex-row items-center gap-2 h-full w-full cursor-pointer"}>
                                                <div className={"w-1/4 content-center"}>
                                                    <div
                                                        className={"ips-individual-image"}
                                                        style={{
                                                            backgroundImage: `url(${getBackgroundImage(event)})`,
                                                            height: "70px"
                                                        }}
                                                    />
                                                </div>
                                                <div className={"w-3/4 min-w-0"}>
                                                    {
                                                        (event.cameraName || event.passagePlace) &&
                                                        <h4 className={"truncate font-normal m-0"} title={event.cameraName ?? event.passagePlace}>
                                                            {event?.cameraName ?? event?.passagePlace ?? ""}
                                                        </h4>
                                                    }

                                                    <p className={"truncate m-0"}>
                                                        {projectUtils.formatDate(event.eventDateTime, "DD/MM/YYYY hh:mm").replace(",", "")}
                                                    </p>

                                                    {
                                                        event?.passageName ?
                                                            <p className={"truncate font-bold m-0"}>
                                                                {event?.passageName}
                                                            </p>
                                                            : event?.individualName &&
                                                            <p className={"truncate font-bold m-0"}>
                                                                {event?.individualName}
                                                            </p>
                                                    }

                                                    {
                                                        event?.provider &&
                                                        <p className={"truncate font-bold m-0"}>
                                                            {event?.provider}
                                                        </p>
                                                    }

                                                    {
                                                        event?.passagePlace &&
                                                        <p className={"truncate font-bold m-0"}>
                                                            {event?.passagePlace}
                                                        </p>
                                                    }

                                                    {
                                                        event?.individualWatchlists &&
                                                        <p className={"truncate text-red-600 font-bold m-0"}>
                                                            {event.individualWatchlists.join(", ")}
                                                        </p>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>

                        {
                            events.length === 100 &&
                            <div className={"text-center italic"}>
                                <small>A pesquisa atingiu o limite de 100 passagens</small>
                            </div>
                        }
                    </>
                }
            </Card.Body>
        </Card>
    );
};

export default PassageResults;
